import { CancelReasons, CustomFields, Entity, ReportTask } from '@nx-smartmonkey/shared/domain';
import { v4 as uuidv4 } from 'uuid';

import { ReportStatus } from '../../constants/Stops';
import { DriversProjectFields } from '../driversProject/DriversProject';
import { StopTask } from '../stop/StopTask';

export interface CreateReportDataProps {
  comments?: string;
  signature?: string;
  customFields?: CustomFields;
  reportTasks?: Array<ReportTask>;
  temporalReportTasks?: Array<ReportTask>;
  temporalTasks?: Array<StopTask>;
  pin?: string;
  cancelReason?: CancelReasons;
}

export type ReportCreateLocation = { lat: number; lng: number };

export type MimeTypes = `image/jpeg` | `image/jpg` | `image/png` | `image/webp`;

export interface ImageUploadedProps {
  tempId: string;
  file_name: string;
  mime_type: MimeTypes;
  data: Blob;
}

export interface StopReportCreateProps {
  location?: ReportCreateLocation;
  stopId: string;
  status: ReportStatus;
  reportData?: CreateReportDataProps;
  images?: Array<ImageUploadedProps>;
  timeInStop?: number;
  createdAt: Date;
}

export class StopReportCreate extends Entity<StopReportCreateProps> {
  private _projectFields: DriversProjectFields;

  get id(): string {
    return this._id!;
  }

  get stopId(): string {
    return this.props.stopId;
  }

  get status(): ReportStatus {
    return this.props.status;
  }

  get location(): ReportCreateLocation | undefined {
    return this.props.location;
  }

  get reportData(): CreateReportDataProps | undefined {
    return this.props.reportData;
  }

  get images(): Array<ImageUploadedProps> | undefined {
    return this.props.images;
  }

  get timeInStop(): number | undefined {
    return this.props.timeInStop;
  }

  get projectFields(): DriversProjectFields {
    return this._projectFields;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  constructor(props: StopReportCreateProps, projectFields: DriversProjectFields, id: string) {
    super(props, id);
    this._projectFields = projectFields;
  }

  static create(props: StopReportCreateProps, projectFields: DriversProjectFields, id?: string) {
    return new StopReportCreate(
      {
        ...props,
        createdAt: props.createdAt ?? new Date(),
      },
      projectFields,
      id ?? uuidv4()
    );
  }
}
